import { type FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

export const LoginRegistrationRegistrationFormCompanyInput: FC = () => {
  const intl = useIntl()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  return (
    <FormControl
      error={!model.validator.isPropertyValid('companyName')}
      required
      value={model.companyName}
    >
      <FormLabel htmlFor="registerForm-company">
        {intl.formatMessage({ id: 'general.label.companyName' })}
      </FormLabel>
      <Input
        {...registrationFormState.makeInputProps('companyName', {
          validateOnBlur: true,
        })}
        id="registerForm-company"
        slotProps={{
          input: {
            'data-qa-id': 'professional-account-register-form-companyName',
          },
        }}
        type="text"
      />
      {model.validator.getFirstErrorFor('companyName') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('companyName')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
